function CollapsibleMenu(params) {
    if(!params) return;
    
    this.setDefaults(params);
    this.addListeners()
}

CollapsibleMenu.prototype.setDefaults = function(params) {
    this.scrollTop = 0;
    this.activeClass = params.activeClass;
    this.fixedBodyClass = params.fixedBodyClass;
    this.slideSpeed = params.slideSpeed;

    this.dom = {
        $trigger: $(params.trigger),
        $body: $(params.body)
    }

    $(".workforce-partnership-header__menu-body").on('keydown', "li:last-child a", this.slide.bind(this));
}

CollapsibleMenu.prototype.addListeners = function() {
    this.dom.$trigger.on('click', this.slide.bind(this));
}

CollapsibleMenu.prototype.slide = function() {
    this.dom.$trigger.toggleClass(this.activeClass);
    this.dom.$body.slideToggle();

    if (this.dom.$trigger.hasClass(this.activeClass)) {
        this.scrollTop = $(window).scrollTop();
        $('body').css('top', -this.scrollTop).addClass(this.fixedBodyClass);
    } else {
        $('body').css('top', null).removeClass(this.fixedBodyClass);
        $(window).scrollTop(this.scrollTop);
    }
}

new CollapsibleMenu({
    activeClass: 'active',
    trigger: '.workforce-partnership-header__menu-trigger',
    body: '.workforce-partnership-header__menu-body',
    fixedBodyClass: 'workforce-partnership__fixed-body'
});